import * as Types from '../../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { PackageFragmentDoc } from './GetPackages.query';
export type GetPackageDetailsQueryVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	iconFormat?: Types.ImageFormat;
	iconProfile?: Types.IconProfile;
	platform?: Types.Platform;
	country: Types.Scalars['Country']['input'];
}>;

export type GetPackageDetailsQuery = {
	__typename?: 'Query';
	node?:
		| { __typename?: 'Article' }
		| { __typename?: 'Author' }
		| { __typename?: 'Bundle' }
		| { __typename?: 'Device' }
		| { __typename?: 'Episode' }
		| { __typename?: 'GenericTitleList' }
		| { __typename?: 'Genre' }
		| { __typename?: 'HomePage' }
		| { __typename?: 'Movie' }
		| { __typename?: 'MultiStepSportEvent' }
		| { __typename?: 'Offer' }
		| { __typename?: 'OfferHistory' }
		| {
				__typename?: 'Package';
				clearName: string;
				id: string;
				shortName: string;
				technicalName: string;
				packageId: number;
				selected: boolean;
				monetizationTypes: Array<Types.MonetizationType>;
				icon: string;
				isVisibleFilterBar: boolean;
				bundles: Array<{
					__typename?: 'Bundle';
					clearName: string;
					icon: string;
					id: string;
					shortName: string;
					technicalName: string;
					bundleId: number;
					selected: boolean;
					packages: Array<{ __typename?: 'Package'; packageId: number; technicalName: string }>;
				}>;
				addons: Array<{
					__typename?: 'Package';
					clearName: string;
					id: string;
					shortName: string;
					technicalName: string;
					packageId: number;
					selected: boolean;
					monetizationTypes: Array<Types.MonetizationType>;
					icon: string;
					isVisibleFilterBar: boolean;
					addonParent?: { __typename?: 'Package'; id: string } | null;
				}>;
				addonParent?: { __typename?: 'Package'; id: string } | null;
		  }
		| { __typename?: 'Page' }
		| { __typename?: 'Person' }
		| { __typename?: 'ProfileV2' }
		| { __typename?: 'Season' }
		| { __typename?: 'Show' }
		| { __typename?: 'SingleStepSportEvent' }
		| { __typename?: 'SportCompetitionV2' }
		| { __typename?: 'SportCompetitorV2' }
		| { __typename?: 'SportMatch' }
		| { __typename?: 'Url' }
		| { __typename?: 'UserProviderSubscription' }
		| null;
};

export const GetPackageDetailsDocument = gql`
	query GetPackageDetails(
		$id: ID!
		$iconFormat: ImageFormat! = WEBP
		$iconProfile: IconProfile! = S100
		$platform: Platform! = WEB
		$country: Country!
	) {
		node(id: $id) {
			... on Package {
				...Package
				bundles(platform: $platform, country: $country) {
					clearName
					icon(format: $iconFormat, profile: $iconProfile)
					id
					shortName
					technicalName
					bundleId
					selected
					packages(country: $country, platform: $platform) {
						packageId
						technicalName
					}
				}
				addons(country: $country, platform: $platform) {
					...Package
				}
			}
		}
	}
	${PackageFragmentDoc}
`;
